<div class="py-8 px-50 flex flex-col justify-center">
  <ng-container>
    <mat-card class="example-card">
      <mat-card>
        <div fxLayout="row" fxLayoutAlign="center center">
          <mat-card-header>
            <mat-card-title>Maladie Professionnel</mat-card-title>
          </mat-card-header>
        </div>
        <mat-card-content fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="start none">
            <mat-form-field appearance="legacy" fxFlex="19">
              <mat-label>Date Debut </mat-label>
              <input matInput [matDatepicker]="pickerDateDeb" [(ngModel)]="dateDeb" (dateChange)="dateDebChange()">
              <mat-datepicker-toggle matSuffix [for]="pickerDateDeb"></mat-datepicker-toggle>
              <mat-datepicker #pickerDateDeb></mat-datepicker>
            </mat-form-field>
            <div fxFlex="3"></div>

            <mat-form-field appearance="legacy" fxFlex="19">
              <mat-label>Date Fin </mat-label>
              <input matInput [matDatepicker]="pickerDateFin" [(ngModel)]="dateFin" (dateChange)="dateFinChange()">
              <mat-datepicker-toggle matSuffix [for]="pickerDateFin"></mat-datepicker-toggle>
              <mat-datepicker #pickerDateFin></mat-datepicker>
            </mat-form-field>
            <div fxFlex="3"></div>
            <button class="bg-green-600 text-white rounded-md p-3 flex items-center mx-4 " style="height: 7vh;" (click)="filtrer()">
              <mat-icon>search</mat-icon>Filtrer
            </button>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="card">
        <div class="py-8 w-full">
          <div class="shadow overflow-auto rounded border-b border-gray-200">
            <table class="w-full bg-white">
              <thead class="bg-gray-800 text-white">
                <tr>
                    <th class="text-center uppercase font-semibold text-xs ">
                      Code
                    </th>
                    <th class="text-center py-3 px-8 uppercase font-semibold text-xs">
                      Employeur
                    </th>
                    <th class="text-center uppercase py-3 px-8 font-semibold text-xs">
                      Victime
                    </th>
                    <th class="text-center py-3 px-8 uppercase font-semibold text-xs">
                      Designation
                    </th>
                    <th class="text-center py-3 px-8 uppercase font-semibold text-xs">
                      Nature de Travaill
  
                    </th>
                    <th class="text-center py-3 px-8 uppercase font-semibold text-xs">
                      Date Arret de Travail
                    </th>
                  </tr>
              </thead>
              <tbody class="text-gray-700 ">
                <ng-container *ngFor="let lm of ListeMaladies; index as i">
                    <tr (click)="rowClick(lm)" class="hover:bg-gray-200">
                        <td class="text-center">
                          {{lm.Id}}
                        </td>
                        <td class="text-center py-3 px-8">
                          {{lm.Employeur_Name}}
                        </td>
                        <td class="text-center">
                          {{lm.Perso_Name}}
                        </td>
                        <td class="text-center py-3 px-8">
                            {{lm.Mal_Designation}}
                            
                        </td>
                        <td class="text-center">
                            {{lm.Mal_Nature_Travail}}
                        </td>
                        <td class="text-center py-3 px-8">
                          {{lm.Mal_DateArret}}
                        </td>
                      </tr>
                </ng-container>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </mat-card>
  </ng-container>
</div>
